import React from 'react';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import ApexFundingAccountDeleteContent from './Content';


const Layout = () => {
  const { pageContentResource: resource } = usePageContentContext();

  return (
    <WizardStepWrapperTemplate
      resource={resource}
      layout={ApexFundingAccountDeleteContent}
      primaryActionLabel="Delete this account"
      LayoutProps={{
        resource,
      }}
      metaOverrideSet={BaseOverride}
      hideErrors
    />
  );
};

export default Layout;
